const redirectToAppStore = () => {
    const userAgent = navigator.userAgent;

    const platformUrls = {
        android: 'https://play.google.com/store/apps/details?id=com.buddybox',
        ios: 'https://apps.apple.com/us/app/buddy-box/id1576514765',
    };

    let redirectToUrl = platformUrls.android;

    if (/android/i.test(userAgent) || /windows/i.test(userAgent)) {
        redirectToUrl = platformUrls.android;
    } else if (/iphone|ipad|ipod/i.test(userAgent) || /macintosh|mac os x/i.test(userAgent)) {
        redirectToUrl = platformUrls.ios;
    }

    window.location.href = redirectToUrl;
}

export default redirectToAppStore